.placeholder-container {
  height: 100%;
  padding-bottom: var(--spacing-bottom-screen-container);
}

.container {
  min-height: 100%;
  padding-bottom: var(--spacing-bottom-screen-container);
  display: flex;
  flex-direction: column;
}
